// Gets binary data for image download from URL
function getImageUrl(url) {
  return new Promise(function (resolve, reject) {
    JSZipUtils.getBinaryContent(url, function (err, data) {
      if (err) {
        reject(err);
      } else {
        resolve(data);
      }
    });
  });
}

async function requestAssets(handle) {
  var data = await jQuery.getJSON("/products/" + handle + ".js");
  return data;
}

$("#downloadImg").on("click", async function () {
  // Set up vars
  var zip = new JSZip();
  var prodHandle = $(this).attr("data-handle");
  var prodTitle = $(this).attr("data-title");
  var img = zip.folder(prodTitle);
  var data = await requestAssets(prodHandle);
  var items = data.images;

  $("#downloadImg").attr("disabled", true);
  $("#downloadImg").addClass("btn--disabled");
  $("#downloadImg").text("Fetching images");
  // Loops through all line items, gets all associated images and adds them to a zip folder
  if (items) {
    for (var i = 0; i < items.length; i++) {
      var filesubstr = items[i].substring(items[i].lastIndexOf("/") + 1);
      var filename = filesubstr.split("?")[0].toLowerCase();
      if (filename.indexOf("private") <= 0) {
        img.file(filename, getImageUrl(items[i]), { binary: true });
      }
    }
  }

  // Saveas function
  zip
    .generateAsync({ type: "blob" }, function updateCallback(metadata) {
      $("#downloadImg").text("Creating .zip file");
    })
    .then(
      function (blob) {
        saveAs(blob, prodTitle + ".zip");
        $("#downloadImg").text("Finished");
      },
      function (err) {
        $("#downloadImg").text(err);
      }
    );
});
